import { render, staticRenderFns } from "./HowToUseBox.vue?vue&type=template&id=0ab2106f"
import script from "./HowToUseBox.vue?vue&type=script&lang=js"
export * from "./HowToUseBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports